<template>
  <div v-if="files.length" class="d-flex flex-column gap-2">
    <div class="small text-muted">Sample attachments - not valid for display. Delivered applicant copies omit the sample marking.</div>
    <div v-for="file in files" :key="file.filename" class="border rounded p-3">
      <a :href="file.url" :download="file.filename">Download {{ file.filename }}</a>
      <details class="mt-2">
        <summary>Preview printable license</summary>
        <iframe :src="file.url" title="Sample printable license" class="w-100 border mt-2" style="height:32rem" />
      </details>
    </div>
  </div>
</template>

<script>
export default {
  props: { attachments: { type: Array, default: () => [] } },
  data() { return { files: [] }; },
  watch: {
    attachments: {
      immediate: true,
      handler(value) {
        this.clearFiles();
        this.files = (value || []).filter(file => file.contentType === 'application/pdf').map(file => ({
          filename: file.filename,
          url: URL.createObjectURL(new Blob([Uint8Array.from(atob(file.content), char => char.charCodeAt(0))], { type: 'application/pdf' }))
        }));
      }
    }
  },
  beforeUnmount() { this.clearFiles(); },
  methods: { clearFiles() { this.files.forEach(file => URL.revokeObjectURL(file.url)); this.files = []; } }
};
</script>
